import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Popconfirm } from 'antd';
import type { FC } from 'react';
import { IconEditPen, IconErase, IconFail, IconSave, IconTrash } from '../../Icon';
import { MiniCopyButton } from '../CopyButton';

interface Props {
  value: string;
  isEditable: boolean;
  onEditButtonClick: () => void;
  onRemoveButtonClick?: () => void;
  onSaveButtonClick: () => void;
  onClearButtonClick?: () => void;
  onCancelButtonClick?: () => void;
  withCopyButton?: boolean;
  askForConfirmationOnRemove?: boolean;
  confirmRemoveText?: string;
  askForConfirmationOnClear?: boolean;
  confirmClearText?: string;
}

export const ToolBar: FC<Props> = ({
  value,
  isEditable,
  onSaveButtonClick,
  onEditButtonClick,
  onRemoveButtonClick,
  onClearButtonClick,
  onCancelButtonClick,
  withCopyButton = false,
  askForConfirmationOnRemove = false,
  confirmRemoveText,
  askForConfirmationOnClear = false,
  confirmClearText,
}) => {
  return (
    <Container className="toolbar">
      {isEditable ? (
        <IconGroup>
          <IconSave onClick={onSaveButtonClick} />
          {onCancelButtonClick != null && <IconFail onClick={onCancelButtonClick} />}
        </IconGroup>
      ) : (
        <IconGroup>
          <IconEditPen title="Edit" onClick={onEditButtonClick} />
          {onClearButtonClick != null && (
            <Popconfirm
              title="Clear!"
              description={confirmClearText}
              onConfirm={onClearButtonClick}
              disabled={!askForConfirmationOnClear}
            >
              <IconErase
                title="Erase"
                onClick={() => !askForConfirmationOnClear && onClearButtonClick()}
              />
            </Popconfirm>
          )}
          {onRemoveButtonClick != null && (
            <Popconfirm
              title="Remove!"
              onConfirm={onRemoveButtonClick}
              description={confirmRemoveText}
              disabled={!askForConfirmationOnRemove}
            >
              <IconTrash
                title="Remove"
                onClick={() => !askForConfirmationOnRemove && onRemoveButtonClick()}
              />
            </Popconfirm>
          )}
          {withCopyButton && <MiniCopyButton title="Copy" copyValue={value} />}
        </IconGroup>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-left: 3px;
`;

const IconGroup = styled.div`
  color: ${RacemapColors.DarkGray};
  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
    cursor: pointer;

    svg:hover {
      transform: scale(1.2);
    }
  }
`;
